export default __webpack_public_path__ + "static/media/agile.598a7774.jpg";